import { render, staticRenderFns } from "./GeneralQuestions.vue?vue&type=template&id=130a3df8&"
import script from "./GeneralQuestions.vue?vue&type=script&lang=js&"
export * from "./GeneralQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports